import React, { Component } from "react";
import moment from "moment";

import history from "../../../history";

import SchoolOverview from "./SchoolOverViewComponent";
import CustomDashboard from "./CustomDashboardComponent";
import { Row, Col } from "react-bootstrap";
import Phi from "../../../Phi/Phi";
import Constants from "../../../Phi/Constants";

import "./Dashboard.css";

import HSGLogo from "../../../Assets/HSG-Logo.png";
import giisLogo from "../../../Assets/giis-logo.png";
import icoGrowthNormal from "../../../Assets/ico-growth-normal.png";
import icoPhysical from "../../../Assets/ico-physical.png";
import icoDental from "../../../Assets/ico-dental.png";
import icoEnt from "../../../Assets/ico-ent.png";
import icoEye from "../../../Assets/ico-eye.png";

const assessmentMap = {
    growth: { name: "Growth Assessment", image: icoGrowthNormal },
    physical: { name: "Physical Assessment", image: icoPhysical },
    ent: { name: "ENT Assessment", image: icoEnt },
    eye: { name: "Eye Assessment", image: icoEye },
    dental: { name: "Dental Assessment", image: icoDental }
};

const getPrettyDate = date => format => moment(date).format(format);

class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cardHeight: "400px"
        };
    }

    componentWillMount() {
        // let organization = JSON.parse(Phi.Storage.getItem("organization"));
        // if (organization) {
        //     // if (this.props.currentProgram && Object.keys(this.props.currentProgram).length > 0) {
        //     //     // let startNode = this.props.currentProgram.billing
        //     //     //     ? this.props.startNodeMap[this.props.currentProgram.billing.id]
        //     //     //     : null;
        //     //     // if (startNode) {
        //     //     //     // this.props.getReport('overview', { eventNodeId: startNode.id, type: 'html' })
        //     //     //     this.props.fetchOverViewReport(startNode.id);
        //     //     // }
        //     // } else {
        //     //     this.props.getProgramByOrganization(organization[0].org_id);
        //     // }
        //     this.props.getProgramByOrganization(organization[0].org_id);
        // }
    }

    componentWillReceiveProps(newProps) {
        // if (JSON.stringify(newProps.currentProgram) !== JSON.stringify(this.props.currentProgram)) {
        //     let startNode = newProps.startNodeMap[newProps.currentProgram.billing.id];
        //     // this.props.getReport('overview', { eventNodeId: startNode.id, type: 'html' })
        //     this.props.fetchOverViewReport(startNode.id);
        // }
    }

    changeHeight = height => {
        this.setState({
            cardHeight: height
        });
    };

    _downloadPdf = () => {
        this.props.setLoader();
        let startNode = this.props.startNodeMap[this.props.currentProgram.billing.id];
        this.props.getReport("overview", { eventNodeId: startNode.id, type: "pdf" });
    };

    handleReportChange = type => {
        let startNode = this.props.currentProgram.billing
            ? this.props.startNodeMap[this.props.currentProgram.billing.id]
            : null;

        window.open(`/report/school/${startNode.id}/${type}`, "_blank");
        //window.open(`/report/school/${startNode.id}/${type}`, "_blank")
    };

    _renderDownloadPdf = () => {
        return (
            <button onClick={() => this._downloadPdf()} className="hsg-btn-consltNow hsg-btn-primary">
                Download Overview Report
            </button>
        );
    };

    getStartNode = (billingId, s_Map) => {
        for (let eachProgram in s_Map) {
            if (s_Map[eachProgram].billing_id === billingId) return eachProgram;
        }
        return false;
    };

    handleReportTimeChange = e => {
        const newBillingId = parseInt(e.target.value, 10);
        const newStartNode = this.getStartNode(newBillingId, this.props.startNodeMap);
        this.props.changeReportInReducer(newBillingId);
        newStartNode && this.props.fetchOverViewReport(this.getStartNode(newBillingId, this.props.startNodeMap));
    };

    getDropDown = programs => (
        <select onChange={e => this.handleReportTimeChange(e)}>
            {programs.map(program => (
                <option key={program.billing.id} value={program.billing.id}>
                    {!!Constants.getNode(program.events, "Schedule Health Checkup")
                        ? Constants.getNode(program.events, "Schedule Health Checkup").event_custom_json
                              .event_scheduled_date
                            ? getPrettyDate(
                                  Constants.getNode(program.events, "Schedule Health Checkup").event_custom_json
                                      .event_scheduled_date
                              )("MMM YYYY")
                            : getPrettyDate(program.billing.billingStartDate)("YYYY")
                        : ""}
                </option>
            ))}
        </select>
    );

    getPrograms = programs => {
        return (
            <h4 style={{ paddingLeft: 20 }}>
                {" "}
                View Detailed Report &nbsp;&nbsp;&nbsp;&nbsp; {this.getDropDown(programs)}
            </h4>
        );
    };

    getUserName = () => {
        let profile = JSON.parse(sessionStorage.getItem('profile'));
        let username = profile.firstname + ' ' + profile.lastname;
        return username;
        // console.log(profile)
        // Boolean(organization.inOrganizationName)
        // ? organization.inOrganizationName
        // : currentProgram.organization_name || ""
    };

    getNoProgramsMessage = () => <h4 style={{ paddingLeft: 20 }}> No Programs to show </h4>;

    _renderSidePanel = () => (
        <Col md={3} lg={2} className="hidden-sm hidden-xs" style={{ padding: 0, display: "block" }} ref="hsg-school-logo">
            <div className="hsg-dashboard-side-panel-container">
                <div className="hsg-dashboard-avatar-container">
                    <img className="hsg-dashboard-partner-image" src={giisLogo} alt="GIIS Logo" />
                </div>
            </div>
        </Col>
    );

    _renderMainBody = () => (
        <Col md={9} lg={10} sm={12} className="hsg-school-overview" ref="hsg-school-overview" style={{display: "inline-block", marginBottom:100}}>
            <Row style={{ paddingLeft: 15 }}>
                <Col md={10} lg={10} sm={12} xs={12}>
                    <h2 className="hsg-school-name">{`Welcome, ${this.getUserName()}`}</h2>
                    <br />
                    <p className="hsg-school-date">{`Today is ${getPrettyDate()("dddd, Do MMM'YYYY")}`}</p>
                </Col>
                <Col md={2} lg={2} xs={12}>
                    {/* {this.props.programs && this.props.programs.length ? <div className="hsg-school-download-pdf">{this._renderDownloadPdf()}</div> : null} */}
                </Col>
            </Row>
            <hr className="very-straight-line" />
            {this.props.programs && this.props.programs.length ? (
                <div id="hsg-frameDiv" style={{ height: this.state.cardHeight }}>
                    {/* <FrameComponent changeHeight={(height) => this.changeHeight(height)} htmlContent={this.props.htmlContent} reportType="schoolOverView" />                                     */}
                    {
                        <CustomDashboard
                            organizationId={this.props.organizationId}
                            fetchEpisodeStats={(organizationId, statLimit, selectedClass, selectedSection) =>
                                this.props.fetchEpisodeStats(organizationId, statLimit, selectedClass, selectedSection)
                            }
                            fetchLatestGrowthOverview={(organizationId, selectedClass, selectedSection) =>
                                this.props.fetchLatestGrowthOverview(organizationId, selectedClass, selectedSection)
                            }
                            episodeStats={this.props.episodeStats}
                            growthOverview={this.props.growthOverview}
                            noDataAvailable={msg => this.props.noDataAvailable(msg)}
                            getSchoolClasses={() => this.props.getSchoolClasses(this.props.organizationId)}
                            classes={this.props.classes}
                        />
                    }

                    {/* {this.getPrograms(this.props.programs)}
                    <br />
                    <br />
                    <div
                        className="hsg-viewAssessment removeviewassesment "
                        style={{ paddingLeft: 20 }}
                        ref="hsg-view-assessment"
                    >
                        {Object.keys(assessmentMap).map((type, i) => {
                            return (
                                <div key={i} className="col-md-6 col-lg-4 col-xs-6 col-sm-6">
                                    <div className="thumbnail normal" onClick={() => this.handleReportChange(type)}>
                                        <img
                                            className="assessment-icon"
                                            src={assessmentMap[type]["image"]}
                                            alt="report icon"
                                        />
                                        <div className="assessment-type">
                                            <div className="assessment-text">{assessmentMap[type]["name"]}</div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}

                    </div> */}

                    {/* <div className="assessment-text" style={{textAlign: "center"}}>Reports not available!</div> */}
                </div>
            ) : (
                this.getNoProgramsMessage()
            )}
        </Col>
    );

    render() {
        return (
            <Col lg={12} md={12} sm={12} xs={12}>
                <section
                    className="hsg-dashboard-container"
                    style={{ minHeight: this.props.dim.contentHeight, fontFamily: "'Exo 2', sans-serif" }}
                >
                    <div className="show-grid">
                        {/* Side Panel */}
                        {this._renderSidePanel()}

                        {this._renderMainBody()}
                    </div>
                </section>
            </Col>
        );
    }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/Containers/DashboardContainer/Component/Dashboard.js